import Vue from 'vue'
import { getSSOProviderInfo } from '@/api/auth'
import LoginModal from '@/components/LoginModal'
import router from './'
import store from '@/store'

export async function showLoginModal() {
    let ssoProviderInfo = {}
    try {
      ssoProviderInfo = await getSSOProviderInfo()
    } catch (err) {
      return Promise.reject({error: err, message: 'Failed to get SSO provider info'});
    }

    return new Promise((resolve, reject) => {
      const LoginModalCtor = Vue.extend(LoginModal)

      // Create and mount relogin modal
      const { email, sso_provider_ids } = store.state.user.user

      const loginModal = new LoginModalCtor({
        propsData: {
          email: email,
          ssoProviders: sso_provider_ids || [],
          ssoProviderInfo
        }
      })

      loginModal.$on('login-success', () => {
        return resolve({message: 'success'})
      })
      loginModal.$on('login-dismissed', () => {
        return reject({message: 'Login error or login dismissed'})
      })

      loginModal.$parent = router.app.$children[0]
      loginModal.$mount()
      router.app.$el.appendChild(loginModal.$el)
    })
  }